// import { createClient } from "@supabase/supabase-js";

// const supabaseUrl = "https://aenumwkysyswabhvgckh.supabase.co";
// const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlbnVtd2t5c3lzd2FiaHZnY2toIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU4NDAwOTgsImV4cCI6MjA1MTQxNjA5OH0.xEzxTT4BXB1pyJsDo9mo_BdIwcnKaeotgpfk8YExi_s";

// const supabase = createClient(supabaseUrl, supabaseKey);

// export default supabase;

// we import the 'createClient' from the library we just installed
import { createClient } from "@supabase/supabase-js";
// this is our Supabase URL
const supabaseUrl = "https://aenumwkysyswabhvgckh.supabase.co";
// environment variable to be updated on the next step
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlbnVtd2t5c3lzd2FiaHZnY2toIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU4NDAwOTgsImV4cCI6MjA1MTQxNjA5OH0.xEzxTT4BXB1pyJsDo9mo_BdIwcnKaeotgpfk8YExi_s";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
